const countryDenmarkOnly: { [key: string]: string } = {
  DK: 'Denmark',
};

export default countryDenmarkOnly;
